import { betStatusDTOMap } from 'src/actions/types'
import type { BetStatusDTO } from 'src/actions/types'
import { betStatusMap, type BetStatus } from 'src/types/domain/BetStatus'

export const fromBetStatusDTO = (status: BetStatusDTO): BetStatus => {
  const map = {
    [betStatusDTOMap.PENDING]: betStatusMap.PENDING,
    [betStatusDTOMap.WON]: betStatusMap.WON,
    [betStatusDTOMap.LOST]: betStatusMap.LOST,
    [betStatusDTOMap.VOIDED]: betStatusMap.CANCELLED,
    [betStatusDTOMap.CASHED_OUT]: betStatusMap.CASHED_OUT
  }

  return map[status]
}
